import type { MapStateToPropsFactory } from 'react-redux';
import { connect } from 'react-redux';
import { FieldMetadataWithValue } from 'state/secondaryMarket/referential/dlpProduct/dlpProduct.model';
import { fromSecondaryMarket } from 'state/selectors';
import type { AppState } from 'state/state.model';
import { getTabIsFrozen } from 'state/workspaces/tabs/tabs.selector';

type OwnProps = Readonly<{
  tabId: string;
}>;

type StateProps = Readonly<{
  isin?: string;
  fieldsMetadata?: FieldMetadataWithValue[];
  isFrozen?: boolean;
}>;

export type DlpSecondaryProductSummaryProps = OwnProps & StateProps;

const mapStateToProps: MapStateToPropsFactory<StateProps, OwnProps, AppState> = () => {
  return (state, { tabId }) => {
    const isin = fromSecondaryMarket.referential.dlpProduct.getSecondaryMarketDlpProductIsinFromTab(state, tabId);
    const fieldsMetadata = fromSecondaryMarket.referential.dlpProduct.getProductSummaryFieldMetadata(state, tabId);
    const isFrozen = getTabIsFrozen(state, tabId) ?? false;
    return {
      isin,
      fieldsMetadata,
      isFrozen,
    };
  };
};

export const connectDlpSecondaryProductSummary = connect(mapStateToProps);
